import { useFormInput } from 'js/lib/form'

const buttonInputs = document.querySelectorAll('.js-c-input--button')
buttonInputs.forEach(initialize)

function initialize(input) {
  const { onDependentChange } = useFormInput(input)
  onDependentChange(dependency => handleDependentChange(input, dependency))
}

function handleDependentChange(input, dependency) {
  switch (dependency.behaviour.type) {
    case 'value':
      updateValue(input, dependency.behaviour.getValue())
      break
    case 'text':
      updateText(input, dependency.behaviour.getText())
      break
  }
}

function updateText(input, value) {
  input.textContent = String(value)
  input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }))
}

function updateValue(input, value) {
  input.value = String(value)
  input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }))
}
